import React, { useEffect, useState, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import DropDownInput from "../DropDownInput/DropDownInput";
import SearchOptions from "components/SearchFilters/searchOptions/searchOptions";
import LoadingBox from "components/loadingBox/loadingBox";
import { FilterContext } from "contextos/FilterContext";
import FiltersForm from "modules/website/components/FiltersForm/FiltersForm";
import SearchOrder from "components/SearchOrder/SearchOrder";

const SearchFilters = () => {
  const [actualColection, setColection] = useState({});
  const [loaded, setLoad] = useState(false);
  const [colections, setFilters] = useState({ data: [], loading: true });
  const [search] = useSearchParams();
  const { filters, cleanner, handleSubmit } = useContext(FilterContext);

  const [startYear, setStartYear] = useState("");
  const [startMonth, setStartMonth] = useState("");
  const [startDay, setStartDay] = useState("");

  const [endYear, setEndYear] = useState("");
  const [endMonth, setEndMonth] = useState("");
  const [endDay, setEndDay] = useState("");

  const catchCollection = (value) => {
    // setSearchParams({});
    if (value) {
      setColection(colections.data.find((col) => col.value === value));
    } else {
      setColection(colections.data.find((col) => col?.isDefault));
    }
  };
  useEffect(() => {
    //console.log(filters);
    if (filters.length > 0) {
      setFilters({ data: filters, loading: false });
    }
  }, [filters]);
  // PARA LOS PARAMS AL INGRESAR A AL SITIO
  /* useEffect(() => {
    setLoad(true); */
  /* let repository = search.get("repository");
  if (repository) {
    setColection(colections.data.find((col) => col.value === repository));
  } */
  /* setColection(colections.data.find((col) => col?.isDefault));
}, [colections, search]); */

  const getYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    years.push({
      displayText: "--",
      selected: false,
      value: ""
    });
    for (let year = 1900; year <= currentYear; year++) {
      years.push({
        displayText: year.toString(),
        selected: false,
        value: year.toString()
      });
    }
    return years;
  };

  const getEndYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    years.push({
      displayText: "--",
      selected: false,
      value: ""
    });
    if (!startYear || startYear === "") {
      for (let year = 1900; year <= currentYear; year++) {
        years.push({
          displayText: year.toString(),
          selected: false,
          value: year.toString()
        });
      }
    } else {
      for (let year = parseInt(startYear); year <= currentYear; year++) {
        years.push({
          displayText: year.toString(),
          selected: false,
          value: year.toString()
        });
      }
    }
    return years;
  };

  //Get months

  const getMonths = () => {
    const months = [
      { displayText: "--", value: "" },
      { displayText: "January", value: "1" },
      { displayText: "February", value: "2" },
      { displayText: "March", value: "3" },
      { displayText: "April", value: "4" },
      { displayText: "May", value: "5" },
      { displayText: "June", value: "6" },
      { displayText: "July", value: "7" },
      { displayText: "August", value: "8" },
      { displayText: "September", value: "9" },
      { displayText: "October", value: "10" },
      { displayText: "November", value: "11" },
      { displayText: "December", value: "12" }
    ];
    return months.map((month) => ({
      ...month,
      selected: false
    }));
  };

  const getDays = (month, year) => {
    const days = [];
    days.push({
      displayText: "--",
      selected: false,
      value: ""
    });

    if (!month || !year) return days;

    const lastDay = new Date(Number(year), Number(month), 0).getDate();

    for (let day = 1; day <= lastDay; day++) {
      days.push({
        displayText: day.toString(),
        selected: false,
        value: day.toString()
      });
    }

    return days;
  };

  useEffect(() => {
    //setLoad(true);
    /* let repository = search.get("repository");
    if (repository) {
      setColection(colections.data.find((col) => col.value === repository));
    } */
    if (colections.data.length > 0) {
      setColection(colections.data.find((col) => col?.isDefault));
    }
    //setColection(colections.data.find((col) => col?.isDefault));
    //setColection(filters[0]);
  }, [colections, search]);

  useEffect(() => {
    if (Object.keys(actualColection).length > 0) {
      setLoad(true);
    }
  }, [actualColection]);

  const renderOptios = () => {
    return (
      <div>
        <SearchOptions colection={actualColection} loaded={loaded} />

        {/* FROM */}
        <div className="row" style={{ marginTop: "16px" }}>
          <div className="col-12 form-group">
            <label style={{ marginBottom: "10px" }}>Filter by Exact Date</label>
            <br />
            <label htmlFor="startyear">From:</label>

            {/* Year */}
            <div className="col-12 form-group d-flex align-items-center">
              <div className="col-3">Year:</div>
              <div className="col-9">
                <DropDownInput
                  name="startyear"
                  options={getYears()}
                  change={setStartYear}
                />
              </div>
            </div>

            {/* Month */}
            {startYear && (
              <div className="col-12 form-group d-flex align-items-center">
                <div className="col-3">Month:</div>
                <div className="col-9">
                  <DropDownInput
                    name="startmonth"
                    options={getMonths()}
                    change={setStartMonth}
                  />
                </div>
              </div>
            )}

            {/* Day */}
            {startYear && startMonth && (
              <div className="col-12 form-group d-flex align-items-center">
                <div className="col-3">Day:</div>
                <div className="col-9">
                  <DropDownInput
                    name="startday"
                    options={getDays(startMonth, startYear)}
                    change={setStartDay}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* TO */}
        <div className="row" style={{ marginTop: "16px" }}>
          <div className="col-12 form-group">
            <label htmlFor="endyear">To:</label>

            {/* Year */}
            <div className="col-12 form-group d-flex align-items-center">
              <div className="col-3">Year:</div>
              <div className="col-9">
                <DropDownInput
                  name="endyear"
                  options={getEndYears()}
                  change={setEndYear}
                />
              </div>
            </div>

            {/* Month */}
            {endYear && (
              <div className="col-12 form-group d-flex align-items-center">
                <div className="col-3">Month:</div>
                <div className="col-9">
                  <DropDownInput
                    name="endmonth"
                    options={getMonths()}
                    change={setEndMonth}
                  />
                </div>
              </div>
            )}

            {/* Day */}
            {endYear && endMonth && (
              <div className="col-12 form-group d-flex align-items-center">
                <div className="col-3">Day:</div>
                <div className="col-9">
                  <DropDownInput
                    name="endday"
                    options={getDays(endMonth, endYear)}
                    change={setEndDay}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* SORT */}
        <div className="row">
          {actualColection?.sortby && (
            <div className="col-12 form-group">
              <hr />
              <label htmlFor="sortby">Order:</label>
              <div style = {{display: "flex", flexDirection: "row"}}>
                <div style = {{width: "80%"}}>
                  <DropDownInput
                    name="sortby"
                    options={actualColection?.sortby}
                  />
                </div>
                <div style = {{width: "20%"}}>
                  <SearchOrder/>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      {loaded && !colections.loading ? (
        <React.Fragment style={{ backgroundColor: '#f5f5f5' }}>
          {/* <div className="row">
            <div className="col-12 form-group">
              <label htmlFor="repository">Acervos:</label>
              <DropDownInput
                name="repository"
                options={colections.data}
                cambio={catchCollection}
                actualColection={actualColection}
              />
            </div>
          </div> */}
          {renderOptios()}
          {/* <FiltersForm /> */}
          {/* BOTON FILROS */}
          <div className="row mt-1">
            {/* <div className="col-12">
              <hr />
              <button className="btn btn-primary col-12">
                Aplicar filtros
              </button>
            </div> */}
            <div className="col-12 mt-2">
              <div
                id="cleanFilters"
                className="btn btn-secondary col-12"
                onClick={() => {
                  /* catchCollection();
                  cleanner(); */
                  handleSubmit()
                  //console.log("Apply filters");
                }}
              >
                Apply filters
              </div>
            </div>
            <div className="col-12 mt-2">
              <div
                id="cleanFilters"
                className="btn btn-secondary col-12"
                onClick={() => {
                  catchCollection();
                  cleanner();
                }}
              >
                Clear filters
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <LoadingBox />
      )}
    </React.Fragment>
  );
};

export default SearchFilters;
